<p-floatlabel variant="on">
  <p-select
    id="cronExpression"
    [options]="cronOptions"
    [(ngModel)]="selectedCron"
    [required]="required"
    (onChange)="onChange($event.value)"
    [showClear]="showClear"
    [style]="style"
    [styleClass]="styleClass"
    [autoDisplayFirst]="false" data-testid="cron-expression-select">
  </p-select>
  <label for="cronExpression">{{label}}</label>
</p-floatlabel>
